import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    FormPageRulesUpdateInput,
    UpdateFormPageRules as UpdateFormPageRulesMutation,
    UpdateFormPageRulesVariables,
} from 'nutshell-graphql-types';

import UPDATE_FORM_PAGE_RULES from '../mutations/update-form-page-rules.graphql';

export function useUpdateFormPageRules(): {
    updateFormPageRules: (input: FormPageRulesUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateFormPageRules, {loading, error}] = useMutation<
        UpdateFormPageRulesMutation,
        UpdateFormPageRulesVariables
    >(UPDATE_FORM_PAGE_RULES);

    return {
        updateFormPageRules: (input: FormPageRulesUpdateInput) => {
            return updateFormPageRules({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
